const

	STATE_REMIX = {

		service: "remix",

		/** file types in storage */
		type: "mp4",

		/** list content per orga or per stream */
		perorga: true,

		/** main screen help */
		help: "Enter the streamname where you will be reMixing. This stream will contain the output video of your realtime session.",

		/** current stream name */
		streamname: null,

		/** currently uploading files */
		uploadingFiles: [],

		/** current token */
		token: null,

		/** remix bitrate */
		bitrate: "2500k",

		valid: false,

		/** current bucket contents */
		content: {},
		cacheKey: Date.now(),

		/** The Current Video being cued (selected but not yet started) */
		cued: undefined,

		/** The current Live Setlist */
		livePlaylist: null,

		/** VTRANS Status of the Live Setlist */
		livePlaylistStatus: null,

		/** The currently editing setlist (offline) */
		currentSetlist: null,

		liveStreamSources: {}
	},

	STATE_WATERMARK = {

		service: "watermark",
		type: "png",
		perorga: true,

		streamname: null,
		uploadingFiles: [],
		content: {},
		cacheKey: Date.now(),
		organization: "",
	},


	STATE_CHROMAKEY_UPLOAD = {

		service: "chromakey",
		types: ["png", "mp4"],
		perorga: true,

		uploadingFiles: [],
		content: {},
		cacheKey: Date.now(),
		organization: "",

		focusedItem: null
	},

	STATE_CHROMAKEY = {

		service: "chromakey",
		type: "mp4",
		perorga: true,

		streamname: null,
		uploadingFiles: [],
		content: {},
		cacheKey: Date.now(),
		organization: "",
		targetStreams: {},
		opcode:{
			color:"00FF00",
			similarity:0.25,
			blending:0.08,
		}
	},

	STATE_REPLAY = {
		service: "replay",
		type: "m3u8",
		perorga: true,
		help: "Enter a streamname to list its replayable sessions. You must have enabled Replay in the Live Processing section of the Bintu Dashboard for the streamname in advance",

		streamname: null,
		session: null,
		content: {},
		cacheKey: Date.now()
	},
	STATE_RECORD = {
		service: "rec",
		type: "mp4",
		perorga: false,
		help: "Enter a streamname to display its associated recordings. Mind that only finished recordings are displayed. You must have enabled Recording for the entered streamname in the Live Processing section of the Bintu Dashboard in advance.",
		streamname: null,
		content: {},
		cacheKey: Date.now()
	},
	STATE_THUMBNAILS = {
		service: "thumbnails",
		help: "Enter a streamname to display its associated thumbnails. You must have enabled Thumbnails in the Live Processing section of the Bintu Dashboard for that streamname in advance",
		streamname: null,
		webroot: "https://bintu-vod-eu-02-ak.nanocosmos.de"
	},

	MAINSTATE = {
		error: null,
		services: {
			replay: STATE_REPLAY,
			watermark: STATE_WATERMARK,
			remix: STATE_REMIX,
			rec: STATE_RECORD,
			chromakey: STATE_CHROMAKEY,
			chromakey_upload: STATE_CHROMAKEY_UPLOAD
		},
		organization: null,
		token: null,
		authentication: {},
		version: null
	};

export default MAINSTATE;
export {STATE_REMIX, STATE_REPLAY, STATE_WATERMARK, STATE_CHROMAKEY, STATE_RECORD, STATE_THUMBNAILS, STATE_CHROMAKEY_UPLOAD};
